<template>
	<div>
		<div>
			<include-elect :parent-id="locationId" :for-create="forCreate" :edit-data="elecData" :disabled="disableAll" @change="handleChangeElect" />
		</div>
		<div>
			<include-gas :parent-id="locationId" :for-create="forCreate" :edit-data="gasData" :disabled="disableAll" @change="handleChangeGas" />
		</div>
		<div>
			<include-water :parent-id="locationId" :for-create="forCreate" :edit-data="waterData" :disabled="disableAll" @change="handleChangeWater" />
		</div>
		<div>
			<fuel-oil :parent-id="locationId" :for-create="forCreate" :edit-data="fuelOilData" :disabled="disableAll" @change="handleChangeFuelOil" />
		</div>
	</div>
</template>

<script>
import IncludeElect from '@/components/LocationService/_Elect';
import IncludeGas from '@/components/LocationService/_Gas';
import IncludeWater from '@/components/LocationService/_Water';
import FuelOil from '@/components/LocationService/FuelOil';
import languageMessages from '@/mixins/languageMessages';

export default {
	name: 'CoTwoPremiseForm',

	components: {
		IncludeElect,
		IncludeGas,
		IncludeWater,
		FuelOil
	},

	props: {
		coTwoData: { type: Object, default: () => ({}), required: false },
		disableAll: { type: Boolean, default: false, required: false }
	},

	mixins: [languageMessages],

	data() {
		return {
			locationId: 0,
			elecData: {
				elecMeterEnd: 0,
				elecMeterEndPict: '',
				elecMeterStart: 0,
				elecMeterStartPict: '',
				elecSupplier: 0,
				consumptionElectricity: 0
			},
			gasData: {
				gasMeterEnd: 0,
				gasMeterEndPict: '',
				gasMeterStart: 0,
				gasMeterStartPict: '',
				gasSupplier: 0,
				consumptionGas: 0
			},
			waterData: {
				waterMeterEnd: 0,
				waterMeterEndPict: '',
				waterMeterStart: 0,
				waterMeterStartPict: '',
				waterSupplier: 0,
				consumptionWater: 0
			},
			fuelOilData: {
				fuelOilVolumeUsed: 0
			},
			greenEnergySupplier: false,
			recycledPaper: false,
			sortedWaste: true,
			paperPrinted: 0,
			forCreate: true
		};
	},

	watch: {
		coTwoData: {
			handler(newVal) {
				this.elecData.elecMeterEnd = newVal.elecMeterEnd;
				this.elecData.elecMeterEndPict = '';
				this.elecData.elecMeterStart = newVal.elecMeterStart;
				this.elecData.elecMeterStartPict = '';
				this.elecData.elecSupplier = newVal.elecSupplier;
				this.elecData.consumptionElectricity = newVal.consumptionElectricity;

				this.gasData.gasMeterEnd = newVal.gasMeterEnd;
				this.gasData.gasMeterEndPict = '';
				this.gasData.gasMeterStart = newVal.gasMeterStart;
				this.gasData.gasMeterStartPict = '';
				this.gasData.gasSupplier = newVal.gasSupplier;
				this.gasData.consumptionGas = newVal.consumptionGas;

				this.waterData.waterMeterEnd = newVal.waterMeterEnd;
				this.waterData.waterMeterEndPict = '';
				this.waterData.waterMeterStart = newVal.waterMeterStart;
				this.waterData.waterMeterStartPict = '';
				this.waterData.waterSupplier = newVal.waterSupplier;
				this.waterData.consumptionWater = newVal.consumptionWater;

				this.fuelOilData.fuelOilVolumeUsed = newVal.fuelOilVolumeUsed;

				this.sortedWaste = newVal.sortedWaste;
				this.paperPrinted = newVal.paperPrinted;
				this.recycledPaper = newVal.recycledPaper;
				this.greenEnergySupplier = newVal.greenEnergySupplier;
			},
			immediate: true,
			deep: true
		}
	},

	computed: {
		yesNoOptions() {
			return [
				{ text: this.FormMSG(15, 'No'), value: false },
				{ text: this.FormMSG(14, 'Yes'), value: true }
			];
		}
	},

	methods: {
		handleChangePaperPrinted() {
			this.emitChange();
		},
		handleChangeRadios() {
			this.emitChange();
		},
		handleChangeFuelOil(payload) {
			this.fuelOilData.fuelOilVolumeUsed = payload.fuelOilVolumeUsed;

			this.emitChange();
		},
		handleChangeWater(payload) {
			this.waterData.waterMeterEnd = payload.waterMeterEnd;
			this.waterData.waterMeterEndPict = payload.waterMeterEndPict;
			this.waterData.waterMeterStart = payload.waterMeterStart;
			this.waterData.waterMeterStartPict = payload.waterMeterStartPict;
			this.waterData.waterSupplier = payload.waterSupplier;
			this.waterData.consumptionWater = payload.consumptionWater;

			this.emitChange();
		},
		handleChangeGas(payload) {
			this.gasData.gasMeterEnd = payload.gasMeterEnd;
			this.gasData.gasMeterEndPict = payload.gasMeterEndPict;
			this.gasData.gasMeterStart = payload.gasMeterStart;
			this.gasData.gasMeterStartPict = payload.gasMeterStartPict;
			this.gasData.gasSupplier = payload.gasSupplier;
			this.gasData.consumptionGas = payload.consumptionGas;

			this.emitChange();
		},
		handleChangeElect(payload) {
			this.elecData.elecMeterEnd = payload.elecMeterEnd;
			this.elecData.elecMeterEndPict = payload.elecMeterEndPict;
			this.elecData.elecMeterStart = payload.elecMeterStart;
			this.elecData.elecMeterStartPict = payload.elecMeterStartPict;
			this.elecData.elecSupplier = payload.elecSupplier;
			this.elecData.consumptionElectricity = payload.consumptionElectricity;

			this.emitChange();
		},
		emitChange() {
			this.$emit('co-two-premise:change', {
				elecData: this.elecData,
				gasData: this.gasData,
				waterData: this.waterData,
				fuelOilData: this.fuelOilData,
				recycledPaper: this.recycledPaper,
				sortedWaste: this.sortedWaste
			});
		}
	}
};
</script>
